export enum Pages {
  Initial = "Initial",
  EnterSerialNumber = "EnterSerialNumber",
  EnterWalletId = "EnterWalletId",
  Connect = "Connect",
  PressPowerBtn = "PressPowerBtn",
  DeviceAuth = "DeviceAuth",
}
